import { useCallback, useEffect, useState } from "react";
import { LogOut, RefreshCw } from "lucide-react";
import { Toaster } from "sonner";
import "./admin.css";
import { adminApi } from "./api";
import AdminLogin from "./AdminLogin";
import AdminStats from "./AdminStats";
import AdminOrders from "./AdminOrders";
import AdminStock from "./AdminStock";

export default function AdminPage() {
  const [authed, setAuthed] = useState(null);
  const [stats, setStats] = useState(null);
  const [orders, setOrders] = useState([]);
  const [stock, setStock] = useState({});
  const [tab, setTab] = useState("orders");

  const load = useCallback(async () => {
    const [s, o, st] = await Promise.all([adminApi.get("/stats"), adminApi.get("/orders"), adminApi.get("/stock")]);
    setStats(s.data); setOrders(o.data); setStock(st.data);
  }, []);

  useEffect(() => {
    adminApi.get("/me").then(() => setAuthed(true)).catch(() => setAuthed(false));
  }, []);
  useEffect(() => { if (authed) load().catch(() => setAuthed(false)); }, [authed, load]);

  const logout = async () => { await adminApi.post("/logout"); setAuthed(false); };

  if (authed === null) return <div className="vf-payment-page"><div className="vf-spinner" /></div>;
  if (!authed) return <><Toaster position="bottom-right" /><AdminLogin onSuccess={() => setAuthed(true)} /></>;

  return (
    <div className="vf-admin" data-testid="admin-dashboard">
      <Toaster position="bottom-right" />
      <header className="vf-admin-bar">
        <a className="vf-admin-logo" href="/" data-testid="admin-logo-link">Vibe<em>Fit</em><small>Atelier</small></a>
        <nav>
          <button className={tab === "orders" ? "active" : ""} onClick={() => setTab("orders")} data-testid="admin-tab-orders">Commandes</button>
          <button className={tab === "stock" ? "active" : ""} onClick={() => setTab("stock")} data-testid="admin-tab-stock">Stock</button>
        </nav>
        <div className="vf-admin-actions">
          <button onClick={() => load()} aria-label="Actualiser" data-testid="admin-refresh-button"><RefreshCw size={15} /></button>
          <button onClick={logout} data-testid="admin-logout-button"><LogOut size={15} /> Quitter</button>
        </div>
      </header>
      <main className="vf-admin-main">
        <AdminStats stats={stats} />
        {tab === "orders" ? <AdminOrders orders={orders} onChanged={load} /> : <AdminStock stock={stock} onChanged={load} />}
      </main>
    </div>
  );
}
